import { FEATURE_CONFIG } from './constants';
import type { FeatureAccessMap } from './types';

export const evaluateFeatureAccess = (
  otherInfo: Record<string, unknown> | null | undefined
): FeatureAccessMap => {
  return FEATURE_CONFIG.reduce((acc, feature) => {
    const raw = otherInfo?.[feature.key];
    acc[feature.key] =
      raw === true || (typeof raw === 'string' && raw.toLowerCase() === 'true');
    return acc;
  }, {} as FeatureAccessMap);
};
